<template>
    <div>
        <accept-subscription-modal v-if="!subscriptionHasBeenAccepted" @subscriptionAcceptedEvent="subscriptionAcceptedListener">
        </accept-subscription-modal>
        <post-activation-password-modals
            v-if="subscriptionHasBeenAccepted"
            :user-name="userName"
            :subscription-was-recently-accepted="subscriptionWasRecentlyAccepted"
        ></post-activation-password-modals>
    </div>
</template>
<script>
import moment from 'moment';
import PostActivationPasswordModals from './PostActivationPasswordModals';
import AcceptSubscriptionModal from './AcceptSubscriptionModal';

export default {
    components: {
        AcceptSubscriptionModal,
        PostActivationPasswordModals,
    },

    props: ['userName', 'subscriptionAccepted'],

    data() {
        return {
            subscriptionHasBeenAccepted: false,
            subscriptionWasRecentlyAccepted: false,
        };
    },

    methods: {
        subscriptionAcceptedListener() {
            this.subscriptionHasBeenAccepted = true;
            this.subscriptionWasRecentlyAccepted = true;
        },
    },

    mounted() {
        if (this.subscriptionAccepted) {
            this.subscriptionHasBeenAccepted = true;
        }
    },
};
</script>
